import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";

/**
 * Fired from the nav items themselves rather than a delegated handler, so the
 * label is the item's own and modal content rendered inside the bar does not
 * count as navigation. nav_variant rides along from the analytics context,
 * which is what makes the two cohorts comparable.
 */
export const useNavClickTracker = (surface: string) => {
  const { track } = useAnalyticsContext();

  return (item: string, destination?: string) =>
    track("Nav Item Clicked", {
      nav_surface: surface,
      nav_item: item,
      nav_destination: destination,
    });
};
